/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const listGroupMembersParamsFirstMax = 100;

export const ListGroupMembersParams = zod.object({
  first: zod.int().min(1).max(listGroupMembersParamsFirstMax).optional(),
  after: zod.string().optional(),
});

export type ListGroupMembersParams = zod.input<typeof ListGroupMembersParams>;
export type ListGroupMembersParamsOutput = zod.output<typeof ListGroupMembersParams>;
